var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-header",
        [
          _c(
            "span",
            { staticClass: "op-left" },
            [
              _c("label", [_vm._v("产品型号：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "el-select el-select-group",
                  model: {
                    value: _vm.defaultProduct,
                    callback: function ($$v) {
                      _vm.defaultProduct = $$v
                    },
                    expression: "defaultProduct",
                  },
                },
                _vm._l(_vm.productList, function (op, value) {
                  return _c("el-option", {
                    key: value,
                    attrs: { label: op.text, value: op.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-button--primary",
                  on: { click: _vm.queryTestList },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "el-button--primary add-btn",
              on: { click: _vm.testOptionAddButton },
            },
            [_vm._v("添加测试用例")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.testItemList, stripe: "", border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "序号", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "用例名称", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "model", label: "产品型号", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "content", label: "测试命令", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "manual",
              label: "是否人工判断",
              formatter: _vm.formatBoolean,
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "step", label: "测试步骤", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "preResult", label: "预期结果", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "180px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.testOptionEditPre(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.testOptionRemovePre(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "添加测试用例",
            width: "50%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { model: _vm.testItem } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "用例名称：",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.testItem.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.testItem, "name", $$v)
                          },
                          expression: "testItem.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "产品型号：",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "el-select el-select-group",
                          model: {
                            value: _vm.testItem.model,
                            callback: function ($$v) {
                              _vm.$set(_vm.testItem, "model", $$v)
                            },
                            expression: "testItem.model",
                          },
                        },
                        _vm._l(_vm.productList, function (op, value) {
                          return _c("el-option", {
                            key: value,
                            attrs: { label: op.text, value: op.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "测试命令：",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.testItem.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.testItem, "content", $$v)
                          },
                          expression: "testItem.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否人工判断：",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.testItem.manual,
                          callback: function ($$v) {
                            _vm.$set(_vm.testItem, "manual", $$v)
                          },
                          expression: "testItem.manual",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "测试步骤：",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.testItem.step,
                          callback: function ($$v) {
                            _vm.$set(_vm.testItem, "step", $$v)
                          },
                          expression: "testItem.step",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "预期结果：",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.testItem.preResult,
                          callback: function ($$v) {
                            _vm.$set(_vm.testItem, "preResult", $$v)
                          },
                          expression: "testItem.preResult",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.testOptionCancel } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.testOptionAdd },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }